import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { CompletePreApprovalRequest } from 'src/app/models/completeRequest';
import { ProcedurePreApprovalRequestDetails } from 'src/app/models/procedurePreApprovalRequestDetails.model';
import { JobProcedureService } from 'src/app/services/sections/job/job-procedure.service';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { ButtonIcons } from '../../action-button/models/button-icons.enum';
import { GenericModalComponent } from '../../generic-modal/generic-modal.component';

@Component({
  selector: 'reject-pre-approval-request',
  templateUrl: './reject-pre-approval-request.component.html',
  styleUrls: ['./reject-pre-approval-request.component.scss',
    '../../stylesheets/job-actions.scss',
    '../../stylesheets/job-main.scss',
    '../../stylesheets/job-inputs.scss',
  ]
})
export class RejectPreApprovalRequestComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('procedurePreApprovalResponseModal') public procedurePreApprovalResponseModal: GenericModalComponent;
  @ViewChild('procedurePreApprovalResponseModalError') public procedurePreApprovalResponseModalError: GenericModalComponent;

  public formModel: FormGroup;
  public procedurePreApprovalRequestDetails: ProcedurePreApprovalRequestDetails;
  public isLoading = false;
  public self = this;
  public readonly ButtonIcons = ButtonIcons;
  private readonly unsubscriber$ = new Subject<void>();

  constructor(
      private router: Router,
      private activatedRoute: ActivatedRoute,
      private procedureService: JobProcedureService
  ) {}

  ngOnInit(): void {
    this.initializeData();
    this.initializeForm();
  }

  ngAfterViewInit(): void {
    GlobalSettingsService.isGlobalLoaderLoading = false;
  }

  public ngOnDestroy(): void {
    this.unsubscriber$.next();
    this.unsubscriber$.complete();
  }

  public submitComment(): void {
    GlobalSettingsService.isSecondaryLoaderLoading = true;

    const updateRequestModel: CompletePreApprovalRequest = {
      isApproved: false,
      completionReason: this.formModel.get('completionReason')?.value,
    };

    this.procedureService
        .updateProcedurePreApprovalRequest(
            this.activatedRoute.snapshot.paramMap.get('token')!,
            updateRequestModel
        )
        .subscribe(
            () => {
              GlobalSettingsService.isSecondaryLoaderLoading = false;
              this.procedurePreApprovalResponseModal.open();
              this.isLoading = false;
            },
            () => {
              GlobalSettingsService.isSecondaryLoaderLoading = false;
              this.procedurePreApprovalResponseModalError.open();
            }
        );
  }

  public closeProcedurePreApprovalResponseModal(){
    this.procedurePreApprovalResponseModal.hide();

    const parentUrl = this.router.url.split('/').slice(0, -1).join('/');
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([parentUrl]);
    });
  }

  private initializeData(): void {
    this.isLoading = true;
    this.procedurePreApprovalRequestDetails = this.activatedRoute.snapshot.data.procedurePreApprovalRequestDetails as ProcedurePreApprovalRequestDetails;
    this.isLoading = false;
  }

  private initializeForm(): void {
    this.formModel = new FormGroup({
      completionReason: new FormControl(null, Validators.required),
    });
  }
}
